import { render } from "./NavHeader.vue?vue&type=template&id=6a222b63"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"

import "./NavHeader.vue?vue&type=style&index=0&id=6a222b63&lang=scss"

import exportComponent from "C:\\Users\\Fede Itti\\vue\\elantiguo_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__